/* ==========================================================================
   Helpers > Sanitize
   ========================================================================== */

/**
 * Sanitize Single Quote
 * @param {string} Text
 */
function sanitizeSingleQuote(text = '') {
    return text.replace(/'/g, '&apos;');
}

/**
 * Sanitize object
 * @param {object}
 * @return {object} cloned object with values sanitized
 */
function sanitizeObject(obj = {}) {
    if (Object.keys(obj) < 1) return obj;

    /* Transform to string first */
    const objString = JSON.stringify(obj);

    return JSON.parse(objString, (key, value) => {
        return typeof value === 'string' ? sanitizeSingleQuote(value) : value;
    });
}

/* Exports */
module.exports = {
    sanitizeSingleQuote,
    sanitizeObject
};
